import React from "react";
import styled from "styled-components";

const Container = styled.div`
    position: absolute;
    top:0;
    left:0;
    height: calc(100vh);
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 32px;
    background: rgba(20, 20, 20, 1);

`;

const IconContainer = styled.div`
    width: 50%;
    height: 50%;
`;


const Loader = () => <Container>
    <IconContainer>
    <lottie-player src="https://assets3.lottiefiles.com/packages/lf20_cbrbre30.json"  background="transparent"  speed="1"  loop  autoplay></lottie-player>
    </IconContainer>
    </Container>;

export default Loader;